/**
 * Site configuration data
 * Ported from OriginalGame/src/data/siteConfig.js
 * 
 * Total sites: 49
 */

import type { SiteConfigMap } from '@/common/types/site.types'

export const siteConfig: SiteConfigMap = {
  "1": {
    id: 1,
    coordinate: {
      x: 152,
      y: 60,
    },
    battleRoom: 2,
    difficulty: [
      1,
      2,
    ],
    workRoom: 2,
    produceValue: 50,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 4,
      },
      {
        itemId: "1101041",
        weight: 3,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 6,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 1,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1101061",
        num: 4,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 1,
      },
      {
        itemId: "1104021",
        num: 1,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 5,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1103094",
        num: 1,
      },
    ],
    unlockValue: {
      site: [
        "2",
        "3",
      ],
    },
    def: 20,
  },
  "2": {
    id: 2,
    coordinate: {
      x: 144,
      y: 287,
    },
    battleRoom: 7,
    difficulty: [
      2,
      3,
    ],
    workRoom: 8,
    produceValue: 278,
    produceList: [
      {
        itemId: "1101011",
        weight: 15,
      },
      {
        itemId: "1101021",
        weight: 15,
      },
      {
        itemId: "1101031",
        weight: 6,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 10,
      },
      {
        itemId: "1104011",
        weight: 5,
      },
      {
        itemId: "1104021",
        weight: 5,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105042",
        weight: 2,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 30,
      },
      {
        itemId: "1103083",
        weight: 3,
      },
      {
        itemId: "1102**",
        weight: 2,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 5,
      },
      {
        itemId: "1105033",
        weight: 1,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 3,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1103094",
        num: 2,
      },
    ],
    unlockValue: {
      site: [
        "4",
        "5",
      ],
    },
    def: 20,
  },
  "3": {
    id: 3,
    coordinate: {
      x: 212,
      y: 127,
    },
    battleRoom: 4,
    difficulty: [
      2,
      3,
    ],
    workRoom: 4,
    produceValue: 138,
    produceList: [
      {
        itemId: "1101011",
        weight: 15,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 4,
      },
      {
        itemId: "1101041",
        weight: 4,
      },
      {
        itemId: "1101051",
        weight: 4,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 2,
      },
      {
        itemId: "1104021",
        weight: 2,
      },
      {
        itemId: "1101061",
        weight: 4,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 20,
      },
      {
        itemId: "1103083",
        weight: 2,
      },
      {
        itemId: "1102**",
        weight: 1,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 3,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 2,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1101061",
        num: 4,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 1,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "10",
        "11",
      ],
    },
    secretRoomsId: 1,
    def: 20,
  },
  "4": {
    id: 4,
    coordinate: {
      x: 40,
      y: 222,
    },
    battleRoom: 6,
    difficulty: [
      3,
      4,
    ],
    workRoom: 4,
    produceValue: 102,
    produceList: [
      {
        itemId: "1101011",
        weight: 5,
      },
      {
        itemId: "1101021",
        weight: 6,
      },
      {
        itemId: "1101031",
        weight: 1,
      },
      {
        itemId: "1101041",
        weight: 4,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 30,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 1,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 3,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 5,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1103094",
        num: 2,
      },
    ],
    unlockValue: {},
    secretRoomsId: 1,
    def: 20,
  },
  "5": {
    id: 5,
    coordinate: {
      x: 410,
      y: 127,
    },
    battleRoom: 10,
    difficulty: [
      3,
      4,
    ],
    workRoom: 5,
    produceValue: 150,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "6",
        "7",
      ],
    },
    def: 20,
  },
  "6": {
    id: 6,
    coordinate: {
      x: 223,
      y: 217,
    },
    battleRoom: 4,
    difficulty: [
      4,
      6,
    ],
    workRoom: 2,
    produceValue: 54,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 5,
      },
      {
        itemId: "1101031",
        weight: 0,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 5,
      },
      {
        itemId: "1103*1",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105042",
        weight: 2,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101061",
        num: 4,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1101061",
        num: 4,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 1,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1103094",
        num: 2,
      },
    ],
    unlockValue: {
      site: [
        "8",
      ],
    },
    def: 30,
  },
  "7": {
    id: 7,
    coordinate: {
      x: 60,
      y: 394,
    },
    battleRoom: 6,
    difficulty: [
      4,
      6,
    ],
    workRoom: 2,
    produceValue: 160,
    produceList: [
      {
        itemId: "1101011",
        weight: 1,
      },
      {
        itemId: "1101021",
        weight: 4,
      },
      {
        itemId: "1101031",
        weight: 1,
      },
      {
        itemId: "1101041",
        weight: 4,
      },
      {
        itemId: "1101051",
        weight: 1,
      },
      {
        itemId: "1101**",
        weight: 1,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 4,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 1,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 1,
      },
    ],
    unlockValue: {
      site: [
        "9",
      ],
    },
    secretRoomsId: 1,
    def: 30,
  },
  "8": {
    id: 8,
    coordinate: {
      x: 100,
      y: 477,
    },
    battleRoom: 8,
    difficulty: [
      4,
      6,
    ],
    workRoom: 6,
    produceValue: 192,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 5,
      },
      {
        itemId: "1101031",
        weight: 0,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 1,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 100,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1103094",
        num: 1,
      },
    ],
    unlockValue: {},
    def: 30,
  },
  "9": {
    id: 9,
    coordinate: {
      x: 490,
      y: 502,
    },
    battleRoom: 10,
    difficulty: [
      5,
      7,
    ],
    workRoom: 5,
    produceValue: 161,
    produceList: [
      {
        itemId: "1101011",
        weight: 100,
      },
      {
        itemId: "1101021",
        weight: 50,
      },
      {
        itemId: "1101031",
        weight: 20,
      },
      {
        itemId: "1101041",
        weight: 20,
      },
      {
        itemId: "1101051",
        weight: 20,
      },
      {
        itemId: "1101**",
        weight: 20,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 1,
    def: 40,
  },
  "10": {
    id: 10,
    coordinate: {
      x: 300,
      y: 127,
    },
    battleRoom: 7,
    difficulty: [
      2,
      3,
    ],
    workRoom: 4,
    produceValue: 113,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 5,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 1,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 1,
      },
      {
        itemId: "1104021",
        weight: 1,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 2,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 25,
      },
      {
        itemId: "1103083",
        weight: 1,
      },
      {
        itemId: "1102**",
        weight: 2,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 1,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101061",
        num: 4,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 1,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "12",
        "13",
      ],
    },
    secretRoomsId: 1,
    def: 20,
  },
  "11": {
    id: 11,
    coordinate: {
      x: 200,
      y: 367,
    },
    battleRoom: 9,
    difficulty: [
      3,
      4,
    ],
    workRoom: 9,
    produceValue: 300,
    produceList: [
      {
        itemId: "1101011",
        weight: 15,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 5,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 2,
      },
      {
        itemId: "1104021",
        weight: 2,
      },
      {
        itemId: "1104043",
        weight: 1,
      },
      {
        itemId: "1105011",
        weight: 20,
      },
      {
        itemId: "1105042",
        weight: 2,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 40,
      },
      {
        itemId: "1103083",
        weight: 5,
      },
      {
        itemId: "1102**",
        weight: 2,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 5,
      },
      {
        itemId: "1105033",
        weight: 3,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1103094",
        num: 1,
      },
    ],
    unlockValue: {},
    secretRoomsId: 2,
    def: 20,
  },
  "12": {
    id: 12,
    coordinate: {
      x: 380,
      y: 573,
    },
    battleRoom: 11,
    difficulty: [
      4,
      6,
    ],
    workRoom: 6,
    produceValue: 202,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 1,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 1,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 2,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 1,
      },
      {
        itemId: "1104021",
        weight: 1,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 60,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 3,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 2,
      },
      {
        itemId: "1302*1",
        weight: 2,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 6,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "14",
      ],
    },
    secretRoomsId: 3,
    def: 30,
  },
  "13": {
    id: 13,
    coordinate: {
      x: 175,
      y: 567,
    },
    battleRoom: 8,
    difficulty: [
      4,
      6,
    ],
    workRoom: 3,
    produceValue: 99,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 1,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105042",
        weight: 3,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1103083",
        weight: 2,
      },
      {
        itemId: "1102**",
        weight: 3,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 1,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 6,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 2,
    def: 30,
  },
  "14": {
    id: 14,
    coordinate: {
      x: 500,
      y: 689,
    },
    battleRoom: 14,
    difficulty: [
      5,
      7,
    ],
    workRoom: 7,
    produceValue: 251,
    produceList: [
      {
        itemId: "1101011",
        weight: 50,
      },
      {
        itemId: "1101021",
        weight: 20,
      },
      {
        itemId: "1101031",
        weight: 5,
      },
      {
        itemId: "1101041",
        weight: 6,
      },
      {
        itemId: "1101051",
        weight: 1,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 2,
      },
      {
        itemId: "1103*1",
        weight: 30,
      },
      {
        itemId: "1104011",
        weight: 2,
      },
      {
        itemId: "1104021",
        weight: 2,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 60,
      },
      {
        itemId: "1103083",
        weight: 3,
      },
      {
        itemId: "1102**",
        weight: 4,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 2,
      },
      {
        itemId: "1302*1",
        weight: 2,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 8,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      npc: [
        5,
      ],
    },
    secretRoomsId: 3,
    def: 40,
  },
  "20": {
    id: 20,
    coordinate: {
      x: 270,
      y: 377,
    },
    battleRoom: 4,
    difficulty: [
      3,
      4,
    ],
    workRoom: 4,
    produceValue: 136,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 5,
      },
      {
        itemId: "1101041",
        weight: 20,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 15,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 2,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 30,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 12,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    def: 20,
  },
  "21": {
    id: 21,
    coordinate: {
      x: 235,
      y: 277,
    },
    battleRoom: 12,
    difficulty: [
      3,
      4,
    ],
    workRoom: 5,
    produceValue: 157,
    produceList: [
      {
        itemId: "1101011",
        weight: 50,
      },
      {
        itemId: "1101021",
        weight: 15,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 15,
      },
      {
        itemId: "1101**",
        weight: 30,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 1,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 15,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 7,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "22",
      ],
    },
    secretRoomsId: 2,
    def: 20,
  },
  "22": {
    id: 22,
    coordinate: {
      x: 60,
      y: 560,
    },
    battleRoom: 10,
    difficulty: [
      4,
      6,
    ],
    workRoom: 5,
    produceValue: 147,
    produceList: [
      {
        itemId: "1101011",
        weight: 75,
      },
      {
        itemId: "1101021",
        weight: 50,
      },
      {
        itemId: "1101031",
        weight: 15,
      },
      {
        itemId: "1101041",
        weight: 20,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 5,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 25,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 8,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 3,
    def: 30,
  },
  "30": {
    id: 30,
    coordinate: {
      x: 240,
      y: 617,
    },
    battleRoom: 7,
    difficulty: [
      3,
      4,
    ],
    workRoom: 5,
    produceValue: 170,
    produceList: [
      {
        itemId: "1101011",
        weight: 60,
      },
      {
        itemId: "1101021",
        weight: 20,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 0,
      },
      {
        itemId: "1101**",
        weight: 20,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 2,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 12,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "31",
      ],
    },
    def: 20,
  },
  "31": {
    id: 31,
    coordinate: {
      x: 490,
      y: 265,
    },
    battleRoom: 6,
    difficulty: [
      4,
      6,
    ],
    workRoom: 4,
    produceValue: 84,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 20,
      },
      {
        itemId: "1101041",
        weight: 3,
      },
      {
        itemId: "1101051",
        weight: 0,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 18,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 1,
    def: 30,
  },
  "32": {
    id: 32,
    coordinate: {
      x: 80,
      y: 310,
    },
    battleRoom: 15,
    difficulty: [
      4,
      6,
    ],
    workRoom: 4,
    produceValue: 126,
    produceList: [
      {
        itemId: "1101011",
        weight: 25,
      },
      {
        itemId: "1101021",
        weight: 20,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 20,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 50,
      },
      {
        itemId: "1103083",
        weight: 2,
      },
      {
        itemId: "1102**",
        weight: 3,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 5,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 14,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "33",
      ],
    },
    def: 30,
  },
  "33": {
    id: 33,
    coordinate: {
      x: 378,
      y: 767,
    },
    battleRoom: 45,
    difficulty: [
      6,
      7,
    ],
    workRoom: 20,
    produceValue: 814,
    produceList: [
      {
        itemId: "1101011",
        weight: 150,
      },
      {
        itemId: "1101021",
        weight: 30,
      },
      {
        itemId: "1101031",
        weight: 20,
      },
      {
        itemId: "1101041",
        weight: 40,
      },
      {
        itemId: "1101051",
        weight: 50,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 2,
      },
      {
        itemId: "1103*1",
        weight: 50,
      },
      {
        itemId: "1104011",
        weight: 10,
      },
      {
        itemId: "1104021",
        weight: 10,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 30,
      },
      {
        itemId: "1105042",
        weight: 10,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 300,
      },
      {
        itemId: "1103083",
        weight: 15,
      },
      {
        itemId: "1102**",
        weight: 6,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1105033",
        weight: 5,
      },
      {
        itemId: "1302*1",
        weight: 5,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
      {
        itemId: "1101071",
        weight: 25,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 28,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "61",
        "301",
      ],
    },
    secretRoomsId: 4,
    def: 40,
  },
  "41": {
    id: 41,
    coordinate: {
      x: 320,
      y: 462,
    },
    battleRoom: 5,
    difficulty: [
      3,
      4,
    ],
    workRoom: 5,
    produceValue: 126,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 15,
      },
      {
        itemId: "1101031",
        weight: 0,
      },
      {
        itemId: "1101041",
        weight: 15,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 20,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 10,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 20,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {
      site: [
        "42",
      ],
    },
    def: 20,
  },
  "42": {
    id: 42,
    coordinate: {
      x: 120,
      y: 611,
    },
    battleRoom: 5,
    difficulty: [
      3,
      4,
    ],
    workRoom: 4,
    produceValue: 163,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 50,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1101073",
        weight: 30,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 16,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    def: 20,
  },
  "43": {
    id: 43,
    coordinate: {
      x: 170,
      y: 497,
    },
    battleRoom: 12,
    difficulty: [
      4,
      6,
    ],
    workRoom: 2,
    produceValue: 72,
    produceList: [
      {
        itemId: "1101011",
        weight: 30,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 0,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 0,
      },
      {
        itemId: "1104021",
        weight: 0,
      },
      {
        itemId: "1104043",
        weight: 0,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 6,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 2,
    def: 30,
  },
  "51": {
    id: 51,
    coordinate: {
      x: 310,
      y: 649,
    },
    battleRoom: 14,
    difficulty: [
      4,
      6,
    ],
    workRoom: 10,
    produceValue: 546,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 3,
      },
      {
        itemId: "1101031",
        weight: 5,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 5,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 0,
      },
      {
        itemId: "1104011",
        weight: 10,
      },
      {
        itemId: "1104021",
        weight: 5,
      },
      {
        itemId: "1104043",
        weight: 4,
      },
      {
        itemId: "1105011",
        weight: 0,
      },
      {
        itemId: "1105042",
        weight: 0,
      },
      {
        itemId: "1105**",
        weight: 0,
      },
      {
        itemId: "1305011",
        weight: 0,
      },
      {
        itemId: "1103083",
        weight: 0,
      },
      {
        itemId: "1102**",
        weight: 0,
      },
      {
        itemId: "1301**",
        weight: 0,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 10,
      },
      {
        itemId: "1302*1",
        weight: 0,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 0,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 16,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    def: 30,
  },
  "52": {
    id: 52,
    coordinate: {
      x: 130,
      y: 747,
    },
    battleRoom: 7,
    difficulty: [
      3,
      4,
    ],
    workRoom: 6,
    produceValue: 168,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 5,
      },
      {
        itemId: "1101031",
        weight: 5,
      },
      {
        itemId: "1101041",
        weight: 5,
      },
      {
        itemId: "1101051",
        weight: 1,
      },
      {
        itemId: "1101**",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 1,
      },
      {
        itemId: "1103*1",
        weight: 5,
      },
      {
        itemId: "1104011",
        weight: 2,
      },
      {
        itemId: "1104021",
        weight: 2,
      },
      {
        itemId: "1104043",
        weight: 2,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 2,
      },
      {
        itemId: "1105**",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 30,
      },
      {
        itemId: "1103083",
        weight: 5,
      },
      {
        itemId: "1102**",
        weight: 5,
      },
      {
        itemId: "1301**",
        weight: 5,
      },
      {
        itemId: "1105022",
        weight: 0,
      },
      {
        itemId: "1105033",
        weight: 0,
      },
      {
        itemId: "1302*1",
        weight: 5,
      },
      {
        itemId: "1106013",
        weight: 0,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 3,
      },
      {
        itemId: "1101021",
        num: 3,
      },
      {
        itemId: "1101031",
        num: 3,
      },
      {
        itemId: "1101041",
        num: 3,
      },
      {
        itemId: "1101051",
        num: 3,
      },
      {
        itemId: "1101073",
        num: 12,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 1,
    def: 20,
  },
  "61": {
    id: 61,
    coordinate: {
      x: 458,
      y: 767,
    },
    difficulty: [],
    produceList: [],
    fixedProduceList: [],
    unlockValue: {},
    def: 20,
  },
  "100": {
    id: 100,
    coordinate: {
      x: 45,
      y: 50,
    },
    difficulty: [],
    produceList: [],
    fixedProduceList: [],
    unlockValue: {},
    def: 20,
  },
  "201": {
    id: 201,
    coordinate: {
      x: 108,
      y: 127,
    },
    battleRoom: 1,
    difficulty: [
      1,
      1,
    ],
    workRoom: 1,
    produceList: [],
    fixedProduceList: [
      {
        itemId: "1101031",
        num: 7,
      },
      {
        itemId: "1101041",
        num: 2,
      },
      {
        itemId: "1101021",
        num: 2,
      },
      {
        itemId: "1101061",
        num: 3,
      },
      {
        itemId: "1103083",
        num: 1,
      },
    ],
    unlockValue: {
      site: [
        "1",
        "202",
      ],
    },
    def: 20,
  },
  "202": {
    id: 202,
    coordinate: {
      x: 130,
      y: 207,
    },
    difficulty: [],
    produceList: [],
    fixedProduceList: [],
    unlockValue: {},
    def: 20,
  },
  "203": {
    id: 203,
    coordinate: {
      x: 490,
      y: 107,
    },
    battleRoom: 9,
    difficulty: [
      1,
      3,
    ],
    workRoom: 4,
    produceValue: 240,
    produceList: [
      {
        itemId: "1101*1",
        weight: 10,
      },
      {
        itemId: "1101071",
        weight: 90,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101*1",
        num: 0,
      },
      {
        itemId: "1101071",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 2,
    def: 50,
  },
  "204": {
    id: 204,
    coordinate: {
      x: 410,
      y: 492,
    },
    battleRoom: 2,
    difficulty: [
      7,
      8,
    ],
    workRoom: 1,
    produceList: [],
    fixedProduceList: [
      {
        itemId: "1101051",
        num: 4,
      },
      {
        itemId: "1101041",
        num: 6,
      },
      {
        itemId: "1101021",
        num: 4,
      },
      {
        itemId: "1102063",
        num: 1,
      },
    ],
    unlockValue: {},
    secretRoomsId: 2,
    def: 40,
  },
  "301": {
    id: 301,
    coordinate: {
      x: 310,
      y: 51,
    },
    battleRoom: 2,
    difficulty: [
      8,
      9,
    ],
    workRoom: 1,
    produceValue: 68,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101021",
        num: 3,
      },
      {
        itemId: "1101011",
        num: 4,
      },
      {
        itemId: "1101073",
        num: 6,
      },
    ],
    unlockValue: {
      site: [
        "302",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "302": {
    id: 302,
    coordinate: {
      x: 387,
      y: 174,
    },
    battleRoom: 3,
    difficulty: [
      8,
      10,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1102022",
        num: 2,
      },
      {
        itemId: "1305011",
        num: 12,
      },
      {
        itemId: "1101073",
        num: 4,
      },
    ],
    unlockValue: {
      site: [
        "303",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "303": {
    id: 303,
    coordinate: {
      x: 208,
      y: 172,
    },
    battleRoom: 3,
    difficulty: [
      8,
      10,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1103011",
        num: 4,
      },
      {
        itemId: "1103083",
        num: 2,
      },
      {
        itemId: "1101073",
        num: 2,
      },
      {
        itemId: "1105022",
        num: 4,
      },
    ],
    unlockValue: {
      site: [
        "304",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "304": {
    id: 304,
    coordinate: {
      x: 521,
      y: 201.5,
    },
    battleRoom: 3,
    difficulty: [
      9,
      10,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1103011",
        num: 4,
      },
      {
        itemId: "1103041",
        num: 4,
      },
      {
        itemId: "1101021",
        num: 3,
      },
      {
        itemId: "1101041",
        num: 4,
      },
      {
        itemId: "1101073",
        num: 3,
      },
    ],
    unlockValue: {
      site: [
        "305",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "305": {
    id: 305,
    coordinate: {
      x: 494.5,
      y: 406,
    },
    battleRoom: 3,
    difficulty: [
      9,
      10,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101021",
        num: 2,
      },
      {
        itemId: "1101031",
        num: 4,
      },
      {
        itemId: "1101051",
        num: 2,
      },
      {
        itemId: "1101073",
        num: 6,
      },
    ],
    unlockValue: {
      site: [
        "306",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "306": {
    id: 306,
    coordinate: {
      x: 298,
      y: 312,
    },
    battleRoom: 4,
    difficulty: [
      9,
      11,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1104011",
        num: 4,
      },
      {
        itemId: "1104021",
        num: 4,
      },
      {
        itemId: "1305011",
        num: 16,
      },
      {
        itemId: "1101073",
        num: 8,
      },
    ],
    unlockValue: {
      site: [
        "307",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "307": {
    id: 307,
    coordinate: {
      x: 523,
      y: 668,
    },
    battleRoom: 4,
    difficulty: [
      9,
      11,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1103041",
        num: 3,
      },
      {
        itemId: "1103011",
        num: 4,
      },
      {
        itemId: "1103083",
        num: 4,
      },
      {
        itemId: "1105022",
        num: 2,
      },
      {
        itemId: "1101073",
        num: 2,
      },
    ],
    unlockValue: {
      site: [
        "308",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "308": {
    id: 308,
    coordinate: {
      x: 110,
      y: 720.5,
    },
    battleRoom: 4,
    difficulty: [
      10,
      11,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1105011",
        num: 12,
      },
      {
        itemId: "1105022",
        num: 4,
      },
      {
        itemId: "1104021",
        num: 4,
      },
      {
        itemId: "1101073",
        num: 5,
      },
    ],
    unlockValue: {
      site: [
        "309",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "309": {
    id: 309,
    coordinate: {
      x: 96,
      y: 439,
    },
    battleRoom: 4,
    difficulty: [
      10,
      11,
    ],
    workRoom: 2,
    produceValue: 98,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1105022",
        num: 4,
      },
      {
        itemId: "1104021",
        num: 2,
      },
      {
        itemId: "1101073",
        num: 5,
      },
    ],
    unlockValue: {
      site: [
        "310",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "310": {
    id: 310,
    coordinate: {
      x: 92,
      y: 162,
    },
    battleRoom: 6,
    difficulty: [
      10,
      12,
    ],
    workRoom: 3,
    produceValue: 118,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
      {
        itemId: "1101071",
        weight: 15,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101021",
        num: 4,
      },
      {
        itemId: "1101031",
        num: 3,
      },
      {
        itemId: "1101041",
        num: 5,
      },
      {
        itemId: "1102042",
        num: 2,
      },
      {
        itemId: "1101073",
        num: 4,
      },
    ],
    unlockValue: {
      site: [
        "311",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "311": {
    id: 311,
    coordinate: {
      x: 298,
      y: 561,
    },
    battleRoom: 6,
    difficulty: [
      11,
      12,
    ],
    workRoom: 3,
    produceValue: 118,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1305011",
        num: 12,
      },
      {
        itemId: "1102033",
        num: 2,
      },
      {
        itemId: "1102042",
        num: 2,
      },
      {
        itemId: "1101073",
        num: 4,
      },
      {
        itemId: "1101073",
        num: 3,
      },
    ],
    unlockValue: {
      site: [
        "312",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "312": {
    id: 312,
    coordinate: {
      x: 338.5,
      y: 775.5,
    },
    battleRoom: 12,
    difficulty: [
      11,
      12,
    ],
    workRoom: 5,
    produceValue: 150,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 10,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 20,
      },
      {
        itemId: "1104011",
        weight: 20,
      },
      {
        itemId: "1104021",
        weight: 20,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1302011",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 5,
      },
      {
        itemId: "1101073",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1305011",
        num: 12,
      },
      {
        itemId: "1101073",
        num: 8,
      },
      {
        itemId: "1103083",
        num: 4,
      },
      {
        itemId: "1104011",
        num: 2,
      },
      {
        itemId: "1104021",
        num: 2,
      },
    ],
    unlockValue: {
      site: [
        "666",
      ],
    },
    secretRoomsId: 5,
    def: 60,
  },
  "400": {
    id: 400,
    coordinate: {
      x: 140,
      y: 407,
    },
    difficulty: [],
    produceList: [],
    fixedProduceList: [],
    unlockValue: {},
    def: 50,
  },
  "500": {
    id: 500,
    coordinate: {
      x: 390,
      y: 420,
    },
    battleRoom: 13,
    difficulty: [
      1,
      3,
    ],
    workRoom: 10,
    produceValue: 320,
    produceList: [
      {
        itemId: "1102011",
        weight: 15,
      },
      {
        itemId: "1102022",
        weight: 15,
      },
      {
        itemId: "1102033",
        weight: 15,
      },
      {
        itemId: "1102042",
        weight: 10,
      },
      {
        itemId: "1103083",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 10,
      },
      {
        itemId: "1102063",
        weight: 5,
      },
      {
        itemId: "1301022",
        weight: 5,
      },
      {
        itemId: "1301033",
        weight: 5,
      },
      {
        itemId: "1301011",
        weight: 10,
      },
      {
        itemId: "1301041",
        weight: 10,
      },
      {
        itemId: "1301052",
        weight: 5,
      },
      {
        itemId: "1301063",
        weight: 5,
      },
      {
        itemId: "1301071",
        weight: 10,
      },
      {
        itemId: "1301082",
        weight: 5,
      },
      {
        itemId: "1302011",
        weight: 10,
      },
      {
        itemId: "1302021",
        weight: 10,
      },
      {
        itemId: "1302032",
        weight: 5,
      },
      {
        itemId: "1302043",
        weight: 5,
      },
      {
        itemId: "1303033",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 1,
      },
      {
        itemId: "1101021",
        num: 1,
      },
      {
        itemId: "1101031",
        num: 1,
      },
      {
        itemId: "1101041",
        num: 1,
      },
      {
        itemId: "1101051",
        num: 1,
      },
      {
        itemId: "1101073",
        num: 1,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 4,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    def: 40,
  },
  "501": {
    id: 501,
    coordinate: {
      x: 300,
      y: 560,
    },
    battleRoom: 8,
    difficulty: [
      4,
      7,
    ],
    workRoom: 7,
    produceValue: 179,
    produceList: [
      {
        itemId: "1101011",
        weight: 30,
      },
      {
        itemId: "1101021",
        weight: 20,
      },
      {
        itemId: "1101031",
        weight: 20,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101051",
        weight: 10,
      },
      {
        itemId: "1104011",
        weight: 5,
      },
      {
        itemId: "1104021",
        weight: 5,
      },
      {
        itemId: "1105011",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 5,
      },
      {
        itemId: "1103083",
        weight: 5,
      },
      {
        itemId: "1105033",
        weight: 5,
      },
      {
        itemId: "1302*1",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 5,
      },
      {
        itemId: "1101021",
        num: 5,
      },
      {
        itemId: "1101031",
        num: 5,
      },
      {
        itemId: "1101041",
        num: 5,
      },
      {
        itemId: "1101051",
        num: 5,
      },
      {
        itemId: "1101073",
        num: 6,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 3,
    def: 50,
  },
  "502": {
    id: 502,
    coordinate: {
      x: 400,
      y: 700,
    },
    battleRoom: 12,
    difficulty: [
      5,
      8,
    ],
    workRoom: 8,
    produceValue: 199,
    produceList: [
      {
        itemId: "1101011",
        weight: 10,
      },
      {
        itemId: "1101021",
        weight: 10,
      },
      {
        itemId: "1101031",
        weight: 20,
      },
      {
        itemId: "1101041",
        weight: 10,
      },
      {
        itemId: "1101061",
        weight: 10,
      },
      {
        itemId: "1101071",
        weight: 20,
      },
      {
        itemId: "1101073",
        weight: 10,
      },
      {
        itemId: "1103041",
        weight: 20,
      },
      {
        itemId: "1103083",
        weight: 10,
      },
      {
        itemId: "1104021",
        weight: 5,
      },
      {
        itemId: "1105051",
        weight: 5,
      },
      {
        itemId: "1302*1",
        weight: 5,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1107052",
        num: 1,
      },
      {
        itemId: "1107042",
        num: 1,
      },
      {
        itemId: "1107032",
        num: 1,
      },
      {
        itemId: "1107022",
        num: 1,
      },
      {
        itemId: "1107012",
        num: 1,
      },
      {
        itemId: "1106014",
        num: 2,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 3,
    def: 60,
  },
  "666": {
    id: 666,
    coordinate: {
      x: 185,
      y: 690,
    },
    battleRoom: 500,
    difficulty: [
      6,
      12,
    ],
    workRoom: 166,
    produceValue: 17123,
    produceList: [
      {
        itemId: "1101011",
        weight: 20,
      },
      {
        itemId: "1101021",
        weight: 20,
      },
      {
        itemId: "1101031",
        weight: 20,
      },
      {
        itemId: "1101041",
        weight: 20,
      },
      {
        itemId: "1101051",
        weight: 20,
      },
      {
        itemId: "1101061",
        weight: 20,
      },
      {
        itemId: "1101073",
        weight: 10,
      },
      {
        itemId: "1102011",
        weight: 5,
      },
      {
        itemId: "1102022",
        weight: 5,
      },
      {
        itemId: "1102033",
        weight: 5,
      },
      {
        itemId: "1102042",
        weight: 5,
      },
      {
        itemId: "1102053",
        weight: 2,
      },
      {
        itemId: "1102063",
        weight: 2,
      },
      {
        itemId: "1103011",
        weight: 10,
      },
      {
        itemId: "1103022",
        weight: 5,
      },
      {
        itemId: "1103033",
        weight: 5,
      },
      {
        itemId: "1103041",
        weight: 10,
      },
      {
        itemId: "1103052",
        weight: 5,
      },
      {
        itemId: "1103063",
        weight: 5,
      },
      {
        itemId: "1103074",
        weight: 5,
      },
      {
        itemId: "1103083",
        weight: 5,
      },
      {
        itemId: "1103094",
        weight: 5,
      },
      {
        itemId: "1104011",
        weight: 5,
      },
      {
        itemId: "1104021",
        weight: 5,
      },
      {
        itemId: "1104032",
        weight: 2,
      },
      {
        itemId: "1104043",
        weight: 2,
      },
      {
        itemId: "1105011",
        weight: 10,
      },
      {
        itemId: "1105022",
        weight: 5,
      },
      {
        itemId: "1105033",
        weight: 5,
      },
      {
        itemId: "1105042",
        weight: 5,
      },
      {
        itemId: "1105051",
        weight: 5,
      },
      {
        itemId: "1106054",
        weight: 1,
      },
      {
        itemId: "1107012",
        weight: 2,
      },
      {
        itemId: "1107022",
        weight: 2,
      },
      {
        itemId: "1107032",
        weight: 2,
      },
      {
        itemId: "1107042",
        weight: 2,
      },
      {
        itemId: "1107052",
        weight: 2,
      },
      {
        itemId: "1301011",
        weight: 5,
      },
      {
        itemId: "1301022",
        weight: 5,
      },
      {
        itemId: "1301033",
        weight: 5,
      },
      {
        itemId: "1301041",
        weight: 5,
      },
      {
        itemId: "1301052",
        weight: 5,
      },
      {
        itemId: "1301063",
        weight: 5,
      },
      {
        itemId: "1101071",
        weight: 5,
      },
      {
        itemId: "1301082",
        weight: 5,
      },
      {
        itemId: "1302011",
        weight: 10,
      },
      {
        itemId: "1302021",
        weight: 10,
      },
      {
        itemId: "1302032",
        weight: 5,
      },
      {
        itemId: "1302043",
        weight: 2,
      },
      {
        itemId: "1303012",
        weight: 5,
      },
      {
        itemId: "1303022",
        weight: 5,
      },
      {
        itemId: "1303033",
        weight: 5,
      },
      {
        itemId: "1303044",
        weight: 5,
      },
      {
        itemId: "1304012",
        weight: 5,
      },
      {
        itemId: "1304023",
        weight: 5,
      },
      {
        itemId: "1305011",
        weight: 50,
      },
    ],
    fixedProduceList: [
      {
        itemId: "1101011",
        num: 1,
      },
      {
        itemId: "1101021",
        num: 0,
      },
      {
        itemId: "1101031",
        num: 0,
      },
      {
        itemId: "1101041",
        num: 0,
      },
      {
        itemId: "1101051",
        num: 0,
      },
      {
        itemId: "1101073",
        num: 0,
      },
      {
        itemId: "1101**",
        num: 0,
      },
      {
        itemId: "1102011",
        num: 0,
      },
      {
        itemId: "1103*1",
        num: 0,
      },
      {
        itemId: "1104011",
        num: 0,
      },
      {
        itemId: "1104021",
        num: 0,
      },
      {
        itemId: "1104043",
        num: 0,
      },
      {
        itemId: "1105011",
        num: 0,
      },
      {
        itemId: "1105042",
        num: 0,
      },
      {
        itemId: "1105**",
        num: 0,
      },
      {
        itemId: "1305011",
        num: 0,
      },
      {
        itemId: "1103083",
        num: 0,
      },
      {
        itemId: "1102**",
        num: 0,
      },
      {
        itemId: "1301**",
        num: 0,
      },
      {
        itemId: "1105022",
        num: 0,
      },
      {
        itemId: "1105033",
        num: 0,
      },
      {
        itemId: "1302*1",
        num: 0,
      },
      {
        itemId: "1106013",
        num: 0,
      },
    ],
    unlockValue: {},
    secretRoomsId: 6,
    def: 50,
  },
}
